import { ICity } from '../admin';

export interface IAirport {
  id?: string;
  legacyId?: number | null;
  iata?: string;
  name?: string;
  city?: ICity;
  longitude?: number;
  latitude?: number;
}

export class Airport implements IAirport {
  constructor(
    public id?: string,
    public iata?: string,
    public name?: string,
    public city?: ICity,
    public longitude?: number,
    public latitude?: number,
    public legacyId?: number | null
  ) {}
}
